export default {
  account_info: '账户信息',
  other_account: '交易账户申请',
  account_application: '期货账户申请',
  records: '资金记录',
  children_account: '银行子账号',
  setting: '设置',
  deposit: '存款记录',
  depositTitle: '存款',
  withdrawal: '取款记录',
  withdrawalTitle: '取款',
  transfer: '内部转账记录',
  transferTitle: '内部转账',
  trade_product: '交易结构性产品申请',
  open_trades: '开放交易',
  close_trades: '关闭交易',
  download: '平台下载',
  'table-download': '文件下载',
  trade_recordes: '交易记录',
  exchange: '换汇',
  quotes: '实时行情服务申请',
  bonds: '买卖债务申请',
  breadcrumb: {
    home: '首页',
    my_account: '我的账户',
    'add-hkCard': '添加香港银行卡',
    account_info: '账户信息',
    bonds: '买卖债务申请',
    other_account: '交易账户申请',
    account_application: '账户申请',
    trade_product: '交易结构性产品申请',
    records: '资金记录',
    deposit: '存款记录',
    depositTitle: '存款',
    withdrawal: '取款记录',
    withdrawalTitle: '取款',
    transfer: '内部转账记录',
    transferTitle: '内部转账',
    children_account: '银行子账号',
    setting: '设置',
    open_trades: '开放交易',
    close_trades: '关闭交易',
    online_bank_deposit: '网上银行转账',
    atm_transfer_deposit: 'ATM 转账',
    bank_transfer_deposit: '银行转账',
    cheque_deposit: '支票存款',
    fps_deposit: 'FPS转数快',
    sub_account_deposit: '子账户存款',
    upload_deposit_reciept: '上传存款收据',
    download: '平台下载',
    'table-download': '文件下载',
    trade_recordes: '交易记录',
    exchange: '换汇',
    quotes: '实时行情服务申请',
    exchangeRecords: '换汇记录'
  }
}
